import { MAX_RECENTLY_PLAYED_GAMES } from './constants';
import { isGenericCasinoGameEntry } from './shared';
import { RecentlyPlayedGame } from './types';
import { PreferencesGetters } from '../types';

export default {
    recentlyPlayedGames(_state: any, getters: PreferencesGetters): string[] {
        const state = getters._userState;
        return state.recentlyPlayedGames
            .filter(isGenericCasinoGameEntry)
            .map((entry) => entry.id);
    },
    recentlyPlayedGamesHomepage(_state: any, getters: PreferencesGetters): RecentlyPlayedGame[] {
        const state = getters._userState;
        return state.recentlyPlayedGames.slice(0, MAX_RECENTLY_PLAYED_GAMES);
    },
};
